export const baseURL = "https://admin.brandsboutique.online/";
export const secretKey = "5TIvw5cpc0";
export const projectName = "Boutique";
